import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../mockData';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src={companyInfo.logo}
              alt="Meskim"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4 max-w-xs">
              {t.hero.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#products" className="text-gray-300 hover:text-teal-400 transition-colors">
                  {t.nav.products}
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-teal-400 transition-colors">
                  {t.nav.about}
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-teal-400 transition-colors">
                  {t.nav.services}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-teal-400 transition-colors">
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t.footer.contactInfo}</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="text-teal-400 mt-1 flex-shrink-0" size={20} />
                <span className="text-gray-300 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-teal-400 flex-shrink-0" size={20} />
                <a 
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-teal-400 flex-shrink-0" size={20} />
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-300 hover:text-teal-400 transition-colors"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Clock className="text-teal-400 flex-shrink-0" size={20} />
                <span className="text-gray-300 text-sm">{t.footer.workingHoursValue}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
